<template lang="pug"></template>

<script>
import BotaoRastreabilidadeSucursales from '@/components/botoesMenu/BotaoRastreabilidadeSucursales';
import BotaoTerritorioSucursales from '@/components/botoesMenu/BotaoTerritorioSucursales';
import BotaoPersonasSucursales from '@/components/botoesMenu/BotaoPersonaSucursales';

export default {
    name: 'BotaoSucursales',
    componentOptions: {
        title: 'BotaoSucursales',
        actions: [
            [
                {
                    name: 'MenuSucursales',
                    iconClass: 'lyra-icon lyra-warehouse',
                    showView: false,
                    nameTranslationKey: 'mensagens.menuLateral.sucursales',
                    submenus: [
                        BotaoRastreabilidadeSucursales,
                        BotaoPersonasSucursales,
                        BotaoTerritorioSucursales
                    ]
                }
            ]
        ]
    }
};
</script>
